<div *ngIf="showDetails == true">
  <p>Da click en el area resaltada para obtener mas informacion</p>

  <div id="btnBack" style="display: none">
    <button (click)="goBack()" class="btn btn-outline-primary btn-sm"><i class="fa fa-arrow-left"></i> Regresar</button>
  </div>

  <div [hidden]="!showBuilding">
    <div class="layout centrado" id="building">
      <img
        #miImagen
        id="miImagen"
        [src]="building?.uri"
        alt="Imagen"
        (load)="createCanvas()"
        style="width: 100%; height: 100%"
      />
      <canvas
        #miCanvas
        id="miCanvas"
        class="cursor-personalizado"
        style="position: absolute; top: 50%; left: 50%; cursor: pointer; transform: translate(-50%, -50%)"
      ></canvas>
    </div>

    <div class="row mt-2 centrado" id="zoom">
      <div class="col d-flex justify-content-center">
        <button
          class="btn btn-primary"
          [style]="
            'background-color:' +
            config?.primaryColor +
            ' !important; border-color:' +
            config?.primaryColor +
            ' !important'
          "
          (click)="zoomIn()"
        >
          <i class="fa fa-search-plus" aria-hidden="true"></i>
        </button>
      </div>
      <div class="col d-flex justify-content-center">
        <button
          class="btn btn-primary"
          [style]="
            'background-color:' +
            config?.primaryColor +
            ' !important; border-color:' +
            config?.primaryColor +
            ' !important'
          "
          (click)="zoomOut()"
        >
          <i class="fa fa-search-minus" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <div style="display: none; overflow: auto; position: relative; min-width: 100%; min-height: 100%" id="layout">
    <app-layout></app-layout>
  </div>
</div>
